import type { JSX } from 'solid-js'
import { For, mergeProps, splitProps } from 'solid-js'
import { twMerge } from 'tailwind-merge'
import type { TagsPropsType } from '~/types/Tags'
import Chip from './Chip'

export default function Tags(props: TagsPropsType): JSX.Element {
  const merged = mergeProps(
    {
      color: 'primary' as const,
      size: 'sm' as const,
      outlined: false,
      tags: [] as string[]
    },
    props
  )

  const [local] = splitProps(merged, ['tags', 'color', 'size', 'outlined', 'class', 'classList', 'onClick'])

  return (
    <div class={twMerge('flex flex-wrap gap-2', local.class || '')} classList={local.classList}>
      <For each={local.tags}>
        {tag => (
          <Chip
            color={local.color}
            size={local.size}
            variant={local.outlined ? 'outlined' : 'filled'}
            onClick={local.onClick ? () => local.onClick?.(tag) : undefined}
            class={twMerge(local.onClick ? 'cursor-pointer' : '', '')}
          >
            {tag}
          </Chip>
        )}
      </For>
    </div>
  )
}
